// React i hooks
import { memo, useCallback, useState } from "react";

// Helpers
import { useTranslate } from "helpers";

// API i konstante
import { FleetWarehouseSearchFormValues } from "services/api/fleet/warehouses/types";
import { initialFleetWarehouseSearchForm } from "services/api/fleet/warehouses/consts";

// UI komponente
import { TextField } from "ui/components/TextField/TextField";

// Dropdown komponente
import ContactDropdown from "ui/components/Dropdown/ContactDropdown/ContactDropdown";
import { DropdownOption } from "ui/components/Dropdown/Dropdown/types";

// Tipovi
import { WarehouseSearchFilterProps } from "./types";


const WarehouseSearchFilters: React.FC<WarehouseSearchFilterProps> = (
  props
) => {
  const { onSearchChange } = props;

  const { t } = useTranslate();

  const [formValues, setFormValues] = useState<FleetWarehouseSearchFormValues>(
    initialFleetWarehouseSearchForm
  );

  const updateFormValues = useCallback(
    (updatedFormValues: FleetWarehouseSearchFormValues) => {
      setFormValues(updatedFormValues);
      onSearchChange(updatedFormValues);
    },
    [onSearchChange]
  );

  const handleTextChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      updateFormValues({ ...formValues, [e.target.name]: e.target.value });
    },
    [formValues, updateFormValues]
  );

  const handleContactChange = useCallback(
    (_e: any, _name: string, item: DropdownOption) => {
      updateFormValues({ ...formValues, contactId: item.value || null });
    },
    [formValues, updateFormValues]
  );

  const handleResetFormClick = useCallback(() => {
    updateFormValues(initialFleetWarehouseSearchForm);
  }, [updateFormValues]);

  return (
    <div className="flex flex-wrap items-end gap-3">
      <div className="min-w-[220px]">
        <TextField
          type="text"
          name="search"
          value={formValues.search}
          onChange={handleTextChange}
          placeholder="Naziv skladišta..."
          startIcon="/media/icons/search.svg"
          cssClassName="bg-white"
        />
      </div>
      <div className="min-w-[220px]">
        <TextField
          type="text"
          name="address"
          value={formValues.address}
          onChange={handleTextChange}
          placeholder="Adresa..."
          startIcon="/media/icons/search.svg"
          cssClassName="bg-white"
        />
      </div>
      <div className="min-w-[220px]">
        <ContactDropdown
          name="contactId"
          placeholder="Kontakt"
          value={formValues.contactId}
          onChange={handleContactChange}
          width="full"
          allowCreate={false}
        />
      </div>
      <div className="flex items-center pb-2">
        <span
          onClick={handleResetFormClick}
          className="text-xs font-bold cursor-pointer text-gray-700"
        >
          {t("admin.reset")}
        </span>
      </div>
    </div>
  );
};
export default memo(WarehouseSearchFilters);
